import { IChannelSettings } from "./Channels";
import { IReport } from "./Report";

export interface IChoiceFormValues {
    img: null | string;
    txt: string;
}

export interface ResourceImage {
    public_url?: string;
    fid?: string;
}

export interface IAuthor {
    _id: string;
    username: string;
    avatar: ResourceImage;
}

export enum ChoiceHTMLSelector {
    txt = "choice-txt-",
    id = "choice-",
}
export interface IChoice {
    _id: string;
    votes: number;
    img: null | ResourceImage;
    txt: string;
}
export interface IComment {
    __v?: number;
    _id: string;
    anonymous_author: string;
    body: string;
    poll_id: string;
    published_date: Date;
    up_votes: number;
}

export interface ICommentForm {
    channelId: string;
    commentId?: string;
    formAction?: string;
    initialText?: string;
    pollId: string;
    setActiveComment?: any;
}

export enum CommentActions {
    EDIT = "edit",
    EDITING = "editing",
}

export enum PollType {
    STANDARD = "standard",
    NPS = "nps",
    MULTIVOTING = "multivoting",
}

export interface IPoll {
    _id: string;
    author: IAuthor;
    channel_id?: string;
    choices: IChoice[];
    comments: {
        count: number;
        isExpanded: boolean;
        isLoading: boolean;
        list: IComment[];
        loadMore: boolean;
    };
    isHideResult: boolean;
    likes: string[];
    privacy: "PRIVATE" | "PUBLIC";
    published: string;
    question: string;
    active: boolean;
    settings?: IChannelSettings;
    total_votes: number;
    multi_voting?: boolean;
    poll_type?: PollType;
    user_choice: string | string[];
    votingTimeLimit: number;
    vote_id?: string | undefined;
    report: null | IReport;
    order?: number;
    private?: boolean;
}

export interface IPollResponse {
    _id: string;
    author: {
        _id: string;
        avatar: ResourceImage;
        username: string;
    };
    channel_id?: string;
    choices: IChoice[];
    comments: {
        count: number;
        isExpanded: boolean;
        isLoading: boolean;
        list: IComment[];
        loadMore: boolean;
    };
    isHideResult: boolean;
    likes: string[];
    privacy: "PRIVATE" | "PUBLIC";
    published: string;
    question: string;
    active: boolean;
    settings?: IChannelSettings;
    total_votes: number;
    multi_voting?: boolean;
    poll_type?: PollType;
    user_choice: string | string[];
    votingTimeLimit: number;
    vote_id: string;
    report: null | IReport;
}
